import { httpRequest } from "../../http";

export class CommandCreateObjective {
    async run(engagementId: number, name: string) {  
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/objectives/`
        const body = {
            name,
        }
        try {
            const response = await httpRequest<any>(url, { method: "POST", body });
            //TODO ADD SERIALIZER
            console.log("Server response:")
            console.log(response)
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    // deserialize(data: any) : EngagementTeam []{
    //     const serializer = new EngagementTeamSerializer();
    //     return serializer.deserializeList(data);
    // }
}

